import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
import { API_PATH } from '../../utils/apis';
import { getCurrentBranch } from '../../utils/jwt';

const initialState = {
    isLoading: false,
    error: false,
    deleteError: false,
    search: '',
    page: 0,
    perPage: 10,
total: 0,
    messages: [],
    summary: {},
    sortBy: null,
    filters: {
        method: ''
    }
};

const slice = createSlice({
    name: 'send',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },
        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        removeDeleteError(state) {
            state.deleteError = false;
        },
        hasDeleteError(state, action) {
            state.isLoading = false;
            state.deleteError = action.payload;
        },
        getSuccess(state, action) {
            state.isLoading = false;
            state.messages = action.payload.data;
            state.summary = action.payload.summary;
            state.total = parseInt(action.payload.total,10);
        },
        deletedSuccess(state, action) {
            const deleted = action.payload.split(",");
            state.messages = state.messages.filter((obj) => !deleted.includes(obj.mid));
            state.isLoading = false;
        },
        //  SORT & FILTER POSTS
        sortBy(state, action) {
            state.sortBy = action.payload;
        },
        filter(state, action) {
            state.filters.method = action.payload.method;
        },
    }
});

// Reducer
export default slice.reducer;

// Actions
export const {
    filter,
    sortBy
} = slice.actions;

export function getMessages(search, type, recipient, stat, page, perpage, order, sortBy) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.post(API_PATH.message, { page, status: stat, search, perpage, order, sortBy, type, recipient, branch : getCurrentBranch() });
            const { status, data, total, summary } = response.data;
            if (status === "success") {
                dispatch(slice.actions.getSuccess({ data, summary, total }));
            } else {
                dispatch(slice.actions.hasError(new Error("We cannot fetch your messages at the moment! Please check back later.")));
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function deleteMessage(remove) {
    return async (dispatch) => {
        dispatch(slice.actions.removeDeleteError());
        try {
            const response = await axios.post(API_PATH.message, { remove });
            if (response.data.status === "success") {
                dispatch(slice.actions.deletedSuccess(remove));
            } else if (response.data.status === "permission_denied") {
                dispatch(slice.actions.hasDeleteError(new Error("You do not have permission to perform this action!")));
            } else {
                dispatch(slice.actions.hasDeleteError(new Error("An error has occured! Please try again later.")));
            }
        } catch (error) {
            dispatch(slice.actions.hasDeleteError(error));
        }
    };
}
